import React from 'react'
import {CheckCircleFilled} from "@ant-design/icons";

interface Props {}

const FeatureCard = ({title, desc}) => {

  return (
    <>
        <div className="card bg-[#F9FAFB] border-0">
            <div className="card-body p-6">
                <div className={"flex flex-row gap-2"}>
                    <CheckCircleFilled style={{color: "#34D399" ,fontSize: "16px"}}/>
                    <p className=" text-md">{title}</p>
                </div>
                <p className={"text-md"}>{desc}</p>
            </div>
        </div>
    </>
  )
}

export default FeatureCard
